module.exports = __webpack_public_path__ + "img/定制化.b482d77a.jpg";